import { render, staticRenderFns } from "./GiftCardChip.vue?vue&type=template&id=2a8a400c&"
import script from "./GiftCardChip.vue?vue&type=script&lang=js&"
export * from "./GiftCardChip.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports